import {useEffect, useState} from "react";
import {FilterData} from "./Filters/Filters";

const calculateWorker: Worker = new Worker(window.location.origin + '/workers/filters-worker.js');
const useFilters = (initialValue: Array<FilterData>) => {
    const [filters, setFilters] = useState<Array<FilterData>>(initialValue);
    const [activeFilters, setActiveFilters] = useState<Array<FilterData>>(initialValue);

    useEffect(() => {
        if (!calculateWorker) return;
        calculateWorker.onmessage = ($event: MessageEvent) => {
            if ($event && $event.data) {
                const {type} = $event.data;

                switch (type) {
                    case "updateFilters":
                        const {
                            updatedFilters,
                            activeFilters
                        } = $event.data.data;
                        setFilters(() => {
                            setActiveFilters(activeFilters);
                            return updatedFilters;
                        });
                        break;
                }

            }
        };
    }, [calculateWorker]);

    const createFilters = (filterArray: Array<any>) => {
        setFilters(filterArray.map(({displayName, fieldName, values}) => ({
            key: fieldName,
            label: displayName || fieldName,
            active: [],
            data: values
        })));
    }

    const setNewFilters = (key: string, values: Array<string>) => {
        setFilters(prevFilters => {
            const updatedFilters = prevFilters.map(filter => ({
                ...filter,
                active: filter.key === key ? values : filter.active,
            }));
            setActiveFilters(updatedFilters.filter(filter => filter.active.length));
            return updatedFilters;
        });
    };

    const setNewFiltersMultiple = (values: Array<{ key: string, values: Array<string> }>) => {
        setFilters(prevFilters => {
            console.log(prevFilters);
            const updatedFilters = prevFilters.map(filter => {
                const item = values.find(item => item.key === filter.key);

                if (item) {
                    const {values} = item;
                    return {
                        ...filter,
                        active: values,
                    }
                }
                return filter;
            });
            setActiveFilters(updatedFilters.filter(filter => filter.active.length));
            return updatedFilters;
        });
    };

    return [filters, activeFilters, setNewFilters, createFilters, setNewFiltersMultiple] as const;
}

export {useFilters};